import { Mail, Phone } from "lucide-react";
import { LOGO_URL, COMPANY, NAV_LINKS } from "../data/content";
import { TikTokIcon, InstagramIcon } from "../components/SocialIcons";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-haas-ink text-haas-cream"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-10 py-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-4 mb-6">
                            <img
                                src={LOGO_URL}
                                alt="Luxe Artificial Grass Ltd"
                                className="h-20 w-20 object-contain rounded-2xl border-2 border-haas-gold shadow-[5px_5px_0_#D4AF37]"
                            />
                            <div>
                                <div className="font-display font-bold text-3xl text-haas-cream tracking-tight">
                                    Luxe
                                </div>
                                <div className="text-[10px] uppercase tracking-[0.25em] text-haas-gold font-bold">
                                    Artificial Grass Ltd
                                </div>
                            </div>
                        </div>
                        <p className="text-haas-cream/75 leading-relaxed max-w-md text-sm">
                            Reliable landscaping across Coventry &amp; the West Midlands — artificial grass, patios, driveways &amp; fencing.
                        </p>

                        {/* Social row */}
                        <div className="mt-6">
                            <div className="text-[10px] uppercase tracking-[0.25em] text-haas-gold font-bold mb-3">
                                Follow us
                            </div>
                            <div className="flex items-center gap-3">
                                <a
                                    href={COMPANY.tiktokUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-tiktok-link"
                                    aria-label="Luxe Artificial Grass on TikTok"
                                    className="group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-black hover:bg-haas-cream hover:text-haas-ink text-white border-2 border-haas-gold/40 hover:border-haas-cream font-semibold text-sm transition-colors"
                                >
                                    <TikTokIcon className="w-4 h-4" />
                                    TikTok
                                </a>
                                <a
                                    href={COMPANY.instagramUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-instagram-link"
                                    aria-label="Luxe Artificial Grass on Instagram"
                                    className="group inline-flex items-center gap-2.5 px-4 py-2.5 rounded-full text-white border-2 border-haas-gold/40 font-semibold text-sm transition-transform hover:scale-[1.03]"
                                    style={{
                                        background:
                                            "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)",
                                    }}
                                >
                                    <InstagramIcon className="w-4 h-4" />
                                    Instagram
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.25em] text-haas-gold font-bold mb-5">
                            Wander
                        </div>
                        <ul className="space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        data-testid={`footer-${l.testid}`}
                                        className="text-haas-cream/85 hover:text-haas-gold text-sm transition-colors"
                                    >
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs uppercase tracking-[0.25em] text-haas-gold font-bold mb-5">
                            Get in touch
                        </div>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a
                                    href={`mailto:${COMPANY.email}`}
                                    data-testid="footer-email-link"
                                    className="inline-flex items-center gap-3 text-haas-cream/85 hover:text-haas-gold transition-colors break-all"
                                >
                                    <Mail className="w-4 h-4 text-haas-gold flex-shrink-0" />
                                    {COMPANY.email}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`tel:${COMPANY.phoneTel}`}
                                    data-testid="footer-phone-link"
                                    className="inline-flex items-center gap-3 text-haas-cream/85 hover:text-haas-gold transition-colors"
                                >
                                    <Phone className="w-4 h-4 text-haas-gold" />
                                    {COMPANY.phone}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-8 border-t border-haas-cream/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 text-xs text-haas-cream/60">
                    <div>
                        © {year} {COMPANY.name}. Company no. {COMPANY.companyNumber}. All rights reserved.
                    </div>
                    <div className="font-hand text-haas-gold text-xl">
                        Green all year round.
                    </div>
                </div>
            </div>
        </footer>
    );
}
